import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchActiveCompany } from "../../redux/company.slice";
import { useTranslation } from "react-i18next";

const CommonFooter = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { company } = useSelector((state) => state.company);

    useEffect(() => {
        if (!company) {
            dispatch(fetchActiveCompany());
        }
    }, [company, dispatch]);

    const year = new Date().getFullYear();

    return (
        <div style={{ marginTop: "50px" }}>
            <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">

                <p className="mb-0">
                    {year} © {company?.companyName || "App"}.{t("footer.rightsReserved")}
                </p>

                <p>
                     {t("footer.createdBy")}
                    <Link
                        to="https://expert-business-solutions.com/"
                        className="text-primary"
                    >
                        &nbsp;&nbsp;Expert Business Solutions
                    </Link>
                </p>

            </div>
        </div>
    );
};

export default CommonFooter;